import { makeStyles } from "@material-ui/core/styles";

const useStyleJumbotron = makeStyles((theme) => ({
  //L'immagine la ricevo tramite props....
  // stabilisco che nello stile 'jumbotronI' l'url dell'immagine di sfondo la gestisco da un props che mi arriverà
  jumbotronI: (props) => ({
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.4)), url(${props.BgImage})`,
    //backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.4)), url("+ (props.BgImage) + ")",
  }),
  jumbotron: {
    height: "42vh",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    /*position: "relative",*/
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
    color: "#fff",
    padding: "4rem 2rem",
    textAlign: "left",
  },
  jumboheader: {
    fontSize: "3.5rem",
    fontWeight: "700",
    lineHeight: "1.2",
    [theme.breakpoints.between("xs", "md")]: {
      fontSize: "3.3vh",
    },
    [theme.breakpoints.between("md", "lg")]: {
      fontSize: "3.5vh",
    },
  },
  lead: {
    fontSize: "1.25rem",
    fontWeight: "300",
    fontStyle: "italic",
    [theme.breakpoints.between("xs", "md")]: {
      lineHeight: "2.9vh",
      fontSize: "2.2vh",
    },
    [theme.breakpoints.between("md", "lg")]: {
    
      fontSize: "2.5vh",
    },
  },
}));

export default useStyleJumbotron;
